import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DNSRecordsArray as SchemaDNSRecordsArray } from '../schemas/DNSRecordsArray';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary DKIM-записи почтового домена
 */
export const GetMailDomainDKIMRecordsContentType = '' as const;
export type GetMailDomainDKIMRecordsRequest = void;
export type GetMailDomainDKIMRecordsResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaDNSRecordsArray;
    };
    /**
     * @description DKIM-record isn't generated yet
     */
    '404': {
        'application/json': SchemaError;
    };
    /**
     * @description Domain is not connected or is delegated to kit.
     */
    '409': {
        'application/json': SchemaError;
    };
};
export type GetMailDomainDKIMRecordsResponseSuccess = GetMailDomainDKIMRecordsResponses['200']['application/json'];
export type GetMailDomainDKIMRecordsSearchParams = undefined;
export type GetMailDomainDKIMRecordsPathParameters = undefined;
export const GetMailDomainDKIMRecordsUrl = '/mail-domain/dkim-records' as const;
export const GetMailDomainDKIMRecordsMethod = 'GET' as const;
export const getGetMailDomainDKIMRecordsUrl = (_params?: GetMailDomainDKIMRecordsPathParameters) =>
    GetMailDomainDKIMRecordsUrl;
